const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`type`] = (((context.has(`type`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`type`) ? context.get(`type`) : null), `text`])) : (`text`));
                this.echo(`
`);
                this.startOutputBuffer();
                this.echo(`  class="c-input`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`"
  `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(new Map([[0, `id`], [1, `name`], [2, `placeholder`], [3, `pattern`], [4, `autocomplete`], [5, `minlength`], [6, `maxlength`], [7, `size`], [8, `min`], [9, `max`], [10, `rows`], [11, `step`], [12, `aria-describedby`]]));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`attribute_name`] = __value__;
                    this.echo(`    `);
                    context.proxy[`attribute_value`] = this.traceableMethod(this.getAttribute, 20, this.source)(this.env, context, context.get(`attribute_name`), new Map(), `any`, false, false, false);
                    this.echo(`    `);
                    if ((context.has(`attribute_value`) ? context.get(`attribute_value`) : null)) {
                        this.echo(this.env.getFilter('escape').traceableCallable(21, this.source)(...[this.env, context.get(`attribute_name`), `html`, null, true]));
                        this.echo(`="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(21, this.source)(...[this.env, (context.has(`attribute_value`) ? context.get(`attribute_value`) : null), `html`, null, true]));
                        this.echo(`"`);
                    }
                    this.echo(`  `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('attribute_name');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(new Map([[0, `autofocus`], [1, `required`], [2, `disabled`], [3, `readonly`]]));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`attribute_name`] = __value__;
                    this.echo(`    `);
                    context.proxy[`attribute_value`] = this.traceableMethod(this.getAttribute, 29, this.source)(this.env, context, context.get(`attribute_name`), new Map(), `any`, false, false, false);
                    this.echo(`    `);
                    if ((context.has(`attribute_value`) ? context.get(`attribute_value`) : null)) {
                        this.echo(this.env.getFilter('escape').traceableCallable(30, this.source)(...[this.env, context.get(`attribute_name`), `html`, null, true]));
                    }
                    this.echo(`  `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('attribute_name');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                context.proxy[`attributes`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
`);
                if (this.compare((context.has(`type`) ? context.get(`type`) : null), `textarea`)) {
                    this.echo(`  <textarea `);
                    this.echo(this.env.getFilter('escape').traceableCallable(35, this.source)(...[this.env, (context.has(`attributes`) ? context.get(`attributes`) : null), `html`, null, true]));
                    this.echo(`>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(35, this.source)(...[this.env, (context.has(`value`) ? context.get(`value`) : null), `html`, null, true]));
                    this.echo(`</textarea>
`);
                }
                else {
                    this.echo(`  <input type="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(37, this.source)(...[this.env, (context.has(`type`) ? context.get(`type`) : null), `html`, null, true]));
                    this.echo(`"`);
                    if ((context.has(`value`) ? context.get(`value`) : null)) {
                        this.echo(` value="`);
                        this.echo(this.env.getFilter('escape').traceableCallable(37, this.source)(...[this.env, (context.has(`value`) ? context.get(`value`) : null), `html`, null, true]));
                        this.echo(`"`);
                    }
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(37, this.source)(...[this.env, (context.has(`attributes`) ? context.get(`attributes`) : null), `html`, null, true]));
                    this.echo(`>
`);
                }
            }

            getTemplateName() {
                return `82b5c0aabb3b925d2284250cbe2e4531b30caabf8cf9e7d781977f3419194b66`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `82b5c0aabb3b925d2284250cbe2e4531b30caabf8cf9e7d781977f3419194b66`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '82b5c0aabb3b925d2284250cbe2e4531b30caabf8cf9e7d781977f3419194b66');

let template = env.loadTemplate('82b5c0aabb3b925d2284250cbe2e4531b30caabf8cf9e7d781977f3419194b66');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/input/input.twig", args: context }
     );
     return rendered;;
};